type IconProps = {
  height?: string;
  width?: string;
}

const AbortIcon = (props: IconProps) => {
  const {height="12", width="12"} = props
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 16 16" fill="none">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M3.30014 4.00737C2.38528 5.0832 1.83325 6.47716 1.83325 8.00004C1.83325 11.4058 4.59416 14.1667 7.99992 14.1667C9.5228 14.1667 10.9168 13.6147 11.9926 12.6998L3.30014 4.00737ZM4.00725 3.30026L12.6997 11.9927C13.6146 10.9169 14.1666 9.52292 14.1666 8.00004C14.1666 4.59428 11.4057 1.83337 7.99992 1.83337C6.47703 1.83337 5.08308 2.3854 4.00725 3.30026ZM0.833252 8.00004C0.833252 4.042 4.04188 0.833374 7.99992 0.833374C11.958 0.833374 15.1666 4.042 15.1666 8.00004C15.1666 11.9581 11.958 15.1667 7.99992 15.1667C4.04188 15.1667 0.833252 11.9581 0.833252 8.00004Z" fill="#E03923"/>
    </svg>
  );
};

export default AbortIcon;
